import {TelehealthBookingEnum} from 'presentation/constants';
import {BookingTypeEnum} from 'presentation/modules/booking/shared/constants/bookingTypeEnum';
import {TELEMEDICINE_INFO} from 'presentation/modules/booking/shared/constants/telemedicineInfo';
import {useBookingFlowStepsStore} from 'presentation/modules/booking/shared/store/useBookingFlowStepsStore';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {getTelehealthStepPosition} from 'presentation/modules/booking/telehealth/utils/getTelehealthStepPosition';
import {useMediaQueries, useQueryParams} from 'presentation/pages';

import {useNavigate} from 'react-router-dom';

export function useTelehealthSection(unitCode: string) {
	const {
		SEARCH_PARAMS: {query},
		clearSearch,
	} = useQueryParams();
	const {isMobile} = useMediaQueries();
	const navigate = useNavigate();
	const setActiveBookingFlowStep = useBookingFlowStepsStore(state => state.setBookingStep);
	const setBookingData = useBookingStore(state => state.setBookingData);

	const handleSelectCard = () => {
		setBookingData(prev => ({
			...prev,
			unitCode,
			unitName: TELEMEDICINE_INFO.name,
			unitAddress: '',
			ufCode: TELEMEDICINE_INFO.ufCode,
			ufName: TELEMEDICINE_INFO.ufName,
			cityName: TELEMEDICINE_INFO.cityName,
			bookingRedirect: true,
			bookingType: BookingTypeEnum.TELEHEALTH,
		}));

		const {PROFESSIONAL_STEP} = getTelehealthStepPosition();

		setActiveBookingFlowStep(PROFESSIONAL_STEP);
		navigate(TelehealthBookingEnum.TELEHEALTH_BOOKING_FLOW);
		clearSearch();
	};

	return {handleSelectCard, query, isMobile};
}
